module.exports = __webpack_public_path__ + "img/dots_mbp4.e6b9deb4.png";